import * as Telecom from '@servicetitan/telecom-rtcs-client';
import { userStatsFromAgentStats } from '../../types/ServiceUser';
import appManager from '@app/appManager';
import {
  ServiceSessionEventType,
  ServiceSessionUserEvent,
} from '../../types/ServiceEvents';
import requireUser from '../../lib/requireUser';
import log from '../../lib/log';
import isValidUser from '../../lib/isValidUser';
import { ServiceUserUtils } from '../../lib/serviceUserUtils';
import { UserSetAvailabilityStatus } from '@api/generated/graphql';
import { setUserStatus } from '../../lib/userStatus';

/**
 * The wrapup complete event indicates the end of wrap-up time.
 * @param event
 */
async function handleAgentRecoveryCompleted(
  event: Telecom.AgentWrapupCompletedEvent,
) {
  if (!isValidUser(event.agentId)) {
    return;
  }

  const user = await requireUser(event.agentId);
  log('rtcs:agent:wrapup_completed:' + user.name, event);

  user.available = event.available;
  ServiceUserUtils.setEventActivityStatus(user, '');
  // If user is available set status to Available, if user not Available
  if (event.available && !ServiceUserUtils.isUserAvailable(user)) {
    setUserStatus({
      userId: user.id,
      status: UserSetAvailabilityStatus.Available,
    });
  }

  user.recoveryTime = event.wrapupTotalMs;
  user.capacity = 1;
  user.stats = userStatsFromAgentStats(event.stats);

  appManager.events.emit<ServiceSessionUserEvent>(
    ServiceSessionEventType.RECOVERY_COMPLETED,
    {
      sessionId: event.conversationId,
      sessionSid: event.conversationSid,
      agentId: event.agentId,
      userId: user.id,
    },
  );
}

export default handleAgentRecoveryCompleted;
